import React from "react";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGraduationCap,
  faBriefcase,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import "../Stylesheets/AboutProgram.css";
import AOS from "aos";

export default function AboutProgramSection() {
  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);
  const programFeatures = [
    {
      icon: faGraduationCap,
      img: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge53416_IMG.jpg",
      title: "Industry-Ready Training",
      description:
        "Hands-on, self-paced learning with real projects and practice.",
      features: [
        "Technical Upskilling with Practicals Labs",
        "Industry Expertise Mentorship",
        "Periodic Evaluation cum Improvement",
      ],
    },
    {
      icon: faBriefcase,
      img: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge16656_IMG.jpg",
      title: " Guaranteed Placement ",
      description:
        "Seamless transition to a paid job with NB Media Tech.",
      features: [
        "Job Assurance Upon Internship Completion",
        "Competitive Remuneration Based on Skills",
        "Exposure to Live Projects and Tasks",
      ],
    },
    {
      icon: faBriefcase,
      img: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge88109_IMG.jpg",

      title: "Career Launchpad",
      description: "Professional Grooming.",
      features: [
        "Employment Extension with Hike",
        "Interview Readiness",
        "Career Growth with Our Organization",
      ],
    },
  ];

  return (
    <section
      id="program"
      className="py-5 position-relative min-vh-100 d-flex flex-column align-items-center"
      data-testid="section-about-program"
    >
      {/* Background video */}
      {/* <div className="program-bg">
        <video loop autoPlay muted playsInline>
          <source src={video} />
        </video>
        <div className="video-overlay"></div>
      </div> */}

      <div className="container program-content position-relative mb-5">
        {/* Section Heading */}
        <div className="row mb-5 text-light">
          <div className="col-lg-8 mx-auto text-center">
            <h2
              className="fw-bold pb-4 program-title gradient-text"
              style={{ fontFamily: "'Merriweather', serif", fontWeight: "800" }}
            >
              <br />
              Why Choose Tech Bridge
            </h2>
            <p className="fs-5" style={{ lineHeight: "1.5" }} data-aos="fade-down">
              {/* Our comprehensive 6-month learning and 1-year Job Guaranteed
              program combines intensive learning with real-world experience,
              ensuring you're job-ready from day one. */}
              From Skill-building to Career Launch, <br />
              Our 6 Month Internship Training and Guaranteed Job Placement Program ensures
              Long Lasting Success.
            </p>
          </div>
        </div>

        {/* Features Grid */}
        <div className="row g-4">
          {programFeatures.map((feature, index) => (
            <div
              key={index}
              className="col-lg-4 col-md-6 "
              data-aos="flip-right"
            >
              <div
                className="card-custom h-100 shadow text-center  p-4"
                style={{ color: " rgb(3 18 48) !important" }}
                data-testid={`card-feature-${index}`}
              >
                <div className="feature-icon mb-3 text-primary fs-1">
                  {/* <FontAwesomeIcon icon={feature.icon} /> */}
                  <img className="programimg" src={feature.img} alt=""/>
                </div>
                <hr />
                <h4
                  className="fw-semibold mb-3"
                  data-testid={`text-feature-title-${index}`}
                >
                  {feature.title}
                </h4>
                <p
                  className="text-secondary"
                  data-testid={`text-feature-description-${index}`}
                >
                  {feature.description}
                </p>
                <ul className="list-unstyled mt-3 text-start">
                  {feature.features.map((item, itemIndex) => (
                    <li
                      key={itemIndex}
                      className="mb-2 d-flex align-items-center"
                      data-testid={`text-feature-item-${index}-${itemIndex}`}
                    >
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="text-success me-2"
                      />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-1"></div>
        <div className="col-lg-4 d-flex align-items-center justify-content-center text-light flex-column" data-aos="fade-right">
          <h1 className=" gradient-text mb-3 text-center " style={{fontFamily:"'Merriweather', serif",fontWeight:"700"}} >
            Hybrid Learning Experience
          </h1>
          <p className=" fs-5 mt-5" style={{ maxWidth: "85%",lineHeight:"2" }}>
            Our unique hybrid learning model combines self-paced online learning
            with in-person mentorship and guidance at our NB Media Tech Pvt Ltd
            in Madurai. Experience the best of both worlds with flexibility and
            direct support.
          </p>
        </div>
          <div className="col-lg-1"></div>
        <div className="col-lg-6 mt-5 d-flex justify-content-center" data-aos="fade-left">
          <img
            src="https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/coding-gif21374_IMG.webp"
            alt="coding"
            className="glow-gif"
            style={{
              width: "80%",
              maxWidth: "800px",
              borderRadius: "16px",
            }}
          />
        </div>
      </div>
    </section>
  );
}
